const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/custom-fields/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/common/hooks/usePermissions';
import { getCustomFieldsQueryOptions } from '@/common/queries/useGetCustomFieldsQuery';
import i18n from '@/common/translations/i18n';
import { customFieldFormSchema } from '@/features/settings/custom-fields/components/types';
const customFieldsSearchSchema = z.object({
  search: z.coerce.string().optional(),
  create: z.boolean().optional().catch(undefined),
  createType: customFieldFormSchema.shape.type.optional().catch(undefined)
});
export const Route = createFileRoute('/(app)/org/$org/settings/custom-fields/')({
  validateSearch: zodValidator(customFieldsSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('edit_integrations'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getCustomFieldsQueryOptions());
    return {
      crumb: i18n.t($ => $.common.settings.customFields.customFields)
    };
  },
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.customFields.customFields)
    }
  }
});